import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEquipment from '../fromEquipment.barrel';

const featureState = createFeatureSelector<fromEquipment.State>(fromEquipment.equipmentFeatureKey);

export const selectActiveFilter = createSelector(featureState, state => state.activeFilter);
export const selectApplications = createSelector(featureState, state => state.hotTapApplications);
export const selectHotTapSizes = createSelector(featureState, state => {
  const sizes = state.tapSizes || [];
  return sizes.map(v => ({ inches: v, centimeters: v * 2.54 }));
});
export const selectFilterResult = createSelector(featureState, state => state.filterResult || []);
export const selectTappingMachines = createSelector(featureState, state => state.tappingMachines);

export const selectLoaders = createSelector(featureState, state => state.loaders);
export const selectIsLoading = (loader: fromEquipment.Loader) => createSelector(selectLoaders, loaders => loaders.includes(loader));
